import $http from 'axios';

export class FileSampleRepo {
  all() {
    return $http.get('/file_samples');
  }

  create(data: any) {
    return $http.post('/file_samples', data);
  }

  update(id: number, data: any) {
    return $http.put(`/file_sample/${id}`, data);
  }

  delete(id: number) {
    return $http.delete(`/file_sample/${id}`);
  }
}
